/**
 * OFIVO Filter-Fix (28.09.2026)
 *
 * Problem: Die von Himbeer Media ergaenzten Klassen theme.LengthRange,
 * theme.WidthRange und theme.HeightRange werden in theme.js ohne Pruefung
 * mit document.querySelector('.length-range') usw. aufgerufen. In Collections
 * ohne Laengen-/Breiten-/Hoehen-Filter (z. B. Standbriefkaesten) ist das
 * Element null, der Konstruktor wirft "Cannot read properties of null
 * (reading 'classList')", und die anschliessende Initialisierung des
 * Filter-Drawers (this.sidebar.init()) wird nie erreicht.
 * Folge: Der Button "Filtern" reagiert nicht.
 *
 * Loesung: Dieses Script wird VOR theme.js geladen und legt auf window.theme
 * Setter fuer die drei Klassen an. Sobald theme.js sie definiert, wird
 * automatisch eine gekapselte Version gespeichert, die bei fehlendem
 * Container einfach nichts tut. Der Original-Code bleibt unveraendert.
 *
 * Hinweis: theme.js startet die Sektionen sofort (document.readyState ist bei
 * defer-Scripts bereits "interactive"), daher reicht ein nachgeladenes Script
 * nicht aus - der Fix muss vorher installiert sein.
 */
(function () {
  window.theme = window.theme || {};

  function install(name) {
    var current = window.theme[name];

    Object.defineProperty(window.theme, name, {
      configurable: true,
      enumerable: true,
      get: function () {
        return current;
      },
      set: function (Original) {
        if (typeof Original !== 'function') {
          current = Original;
          return;
        }
        var Guarded = function (container, options) {
          if (!container) return {};
          return Original.call(this, container, options);
        };
        Guarded.prototype = Original.prototype;
        current = Guarded;
      }
    });
  }

  ['LengthRange', 'WidthRange', 'HeightRange'].forEach(install);
})();
